import client from "../client/client";

class LicenceManagementService {
	getListUsers({ page, limit, payload }, cancelToken) {
		return client.get("/veolia/backoffice/users", {
			payload: JSON.stringify(payload),
			params: { page, limit, username: payload.username, sort: payload.sort, direction: payload.direction },
			config: { cancelToken },
		});
	}

	getProfile(cancelToken) {
		return client.get("/veolia/backoffice/companies/roles", {
			config: { cancelToken },
		});
	}

	getListBUByUser({ page, limit, userId, payload }, cancelToken) {
		return client.get(`/veolia/backoffice/users/${userId}/contracts/companies`, {
			payload: JSON.stringify(payload),
			params: {
				page,
				limit,
				buName: payload.buName,
				sort: payload.sort,
				direction: payload.direction,
				active: payload.active,
			},
			config: { cancelToken },
		});
	}

	getListProjectByBuAndUser({ page, limit, payload }, cancelToken) {
		return client.get(`/veolia/backoffice/${payload.userId}/companyId/${payload.companyId}/projects`, {
			payload: JSON.stringify(payload),
			params: { page, limit, projectName: payload.projectName, sort: payload.sort, direction: payload.direction },
			config: { cancelToken },
		});
	}

	getAllListBU({ page, limit, payload }, cancelToken) {
		return client.get("/veolia/backoffice/contracts/companies", {
			payload: JSON.stringify(payload),
			params: { page, limit, buName: payload.buName, sort: payload.sort, direction: payload.direction },
			config: { cancelToken },
		});
	}

	switchBlockedUser({ userId }, cancelToken) {
		return client.post(`/veolia/backoffice/users/${userId}`, {
			config: { cancelToken },
		});
	}

	addUser({ payload }, cancelToken) {
		return client.post("veolia/backoffice/users", {
			payload: JSON.stringify(payload),
			config: { cancelToken },
		});
	}

	getStatusCertificatByUser({ userId }, cancelToken) {
		return client.get(`veolia/backoffice/users/${userId}/certificats`, {
			config: { cancelToken },
		});
	}

	lockAccessUserByCompany({ userId, companyId }, cancelToken) {
		return client.post(`veolia/backoffice/users/${userId}/companies/${companyId}/lock`, {
			config: { cancelToken },
		});
	}

	unlockAccessUserByCompany({ userId, companyId }, cancelToken) {
		return client.delete(`veolia/backoffice/users/${userId}/companies/${companyId}/unlock`, {
			config: { cancelToken },
		});
	}

	addAccessUserCertificate({ userId, payload }, cancelToken) {
		return client.post(`veolia/backoffice/users/${userId}/certificats`, {
			payload: JSON.stringify(payload),
			config: { cancelToken },
		});
	}

	updateProfile({ userId, payload }, cancelToken) {
		return client.patch(`veolia/backoffice/roles/users/${userId}`, {
			payload: JSON.stringify(payload),
			config: { cancelToken },
		});
	}

	updateUserStatusInProject({ userId, payload, companyId, projectId }, cancelToken) {
		return client.put(`/veolia/backoffice/users/${userId}/companies/${companyId}/projects/${projectId}`, {
			payload: JSON.stringify(payload),
			config: { cancelToken },
		});
	}

	addRoleUserToBu({ userId, companyId, payload }, cancelToken) {
		return client.post(`veolia/backoffice/users/${userId}/company/${companyId}/contracts`, {
			payload: JSON.stringify(payload),
			config: { cancelToken },
		});
	}

	deleteRoleUserToBu({ userId, companyId, payload }, cancelToken) {
		return client.patch(`veolia/backoffice/users/${userId}/company/${companyId}/contracts`, {
			payload: JSON.stringify(payload),
			config: { cancelToken },
		});
	}

	getUserCommitmentAccess({ userId }, cancelToken) {
		return client.get(`veolia/backoffice/users/${userId}/commitment`, {
			config: { cancelToken },
		});
	}

	updateUserCommitmentAccess({ userId, add }, cancelToken) {
		return client.patch(`veolia/backoffice/users/${userId}/commitment`, {
			params: { add },
			config: { cancelToken },
		});
	}
}
export default new LicenceManagementService();
